<!--<div class="divContainer" style="top:-10px;">-->

<button type="button" id="BtnPopup" (click)="GetFreelancerDetailsByID()" style="display:none">Search</button>
<button type="button" id="btnDownloadDT" (click)="Resumefiledownload()" style="display:none"></button>
<button type="button" id="BtnAssignment" (click)="GetAssignmentPopup()" style="display:none"></button>
<button type="button" id="BtnAdd" (click)="GetAssessmentpopup()" style="display:none"></button>
<button type="button" (click)="showInvite()" id="btn_AddNew" style="display:none">Add</button>
<button type="button" (click)="DeleteInviteFreelancer()" id="btnDeleteInviteFreelancer" style="display:none">Add</button>
<button type="button" (click)="DeleteInviteFreelancerConfirmation()" id="btnDeleteInviteFreelancerConfirmation" style="display:none">Add</button>
<div id="LoadingImage">
  <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
</div>

<div class="row" id="divSummaryIndex">
  <div class="col-12 col-sm-7 col-md-2">
    <div class="info-box">
      <span class="info-box-icon bg-blue elevation-1"><i class="fa fa-edit"></i></span>
      <div class="info-box-content">
        <span class="info-box-text">Freelancer List</span>
        <span class="info-box-number">{{FreelancerList}}</span>
      </div>

    </div>
  </div>

  <div class="col-12  col-sm-7 col-md-2">
    <div class="info-box mb-3">
      <span class="info-box-icon bg-yellow elevation-1"><i class="fas fa-sign-in-alt"></i></span>
      <div class="info-box-content">
        <span class="info-box-text">Assignment Pending</span>
        <span class="info-box-number">{{AssignmentPending}}</span>
      </div>
    </div>
  </div>

  <div class="col-12  col-sm-7 col-md-2">
    <div class="info-box mb-3">
      <span class="info-box-icon bg-orange elevation-1"><i class="fas fa-user-clock"></i></span>
      <div class="info-box-content">
        <span class="info-box-text">Assign Return Pending</span>
        <span class="info-box-number">{{AssignReturnPending}}</span>
      </div>
    </div>
  </div>
  <div class="col-12  col-sm-7 col-md-2">
    <div class="info-box mb-3">
      <span class="info-box-icon bg-purple elevation-1"><i class="fas fa-user-edit"></i></span>
      <div class="info-box-content">
        <span class="info-box-text">Assessment Pending</span>
        <span class="info-box-number">{{AssesmentPending}}</span>
      </div>
    </div>
  </div>
  <div class="col-12  col-sm-7 col-md-2">
    <div class="info-box mb-3">
      <span class="info-box-icon bg-green elevation-1"><i class="fas fa-user-check"></i></span>
      <div class="info-box-content">
        <span class="info-box-text">Selected</span>
        <span class="info-box-number">{{Selected}}</span>
      </div>
    </div>
  </div>

  <div class="col-12  col-sm-7 col-md-2">

    <div class="info-box mb-3">
      <span class="info-box-icon bg-red elevation-1"><i class="fas fa-user-alt-slash"></i></span>
      <div class="info-box-content">
        <span class="info-box-text">Reject</span>
        <span class="info-box-number">{{Reject}}</span>
      </div>
    </div>
  </div>


</div>


<!--PM DashBoard-->
<div class="row">
  <!--<div class="col-sm-6">
    <h5 style="background-color: #dde1ff66;text-align:center">Freelancer Data</h5>
    <table #dataTable class="display" style="width:100%" id="tblMainList"></table>
  </div>-->
  <div class="col-sm-12 form-group" id="reports">
    <ul class="nav nav-tabs nav-tabs-custom" id="ULTabul">
      <li class="nav-item"><a data-toggle="tab" href="#divFreelancerData" class="nav-link active">Freelancer Data</a></li>
      <li class="nav-item"><a data-toggle="tab" href="#divAssignmentPending" class="nav-link">Assignment Pending</a></li>
      <li class="nav-item"><a data-toggle="tab" href="#divAssessmentPending" class="nav-link">Assessment Pending</a></li>
    </ul>
    <br />
    <div class="tab-content">
      <div class="tab-pane active" id="divFreelancerData">
        <div class="row col-sm-12" id="reports">
          <table #dataTable class="display" style="width:100%" id="tblMainList"></table>
        </div>
      </div>
      <div class="tab-pane" id="divAssignmentPending">
        <div class="row col-sm-12" id="reports">
          <!--<h5 style="background-color: #dde1ff66;text-align:center">Assignment Pending</h5>-->
          <table #dataTableAssign class="display" style="width:100%" id="tblAssignmentPendingList"></table>
        </div>
      </div>
      <div class="tab-pane" id="divAssessmentPending">
        <div class="row col-sm-12" id="reports">
          <!--<h5 style="background-color: #dde1ff66;text-align:center">Assessment Pending</h5>-->
          <table #dataTableRP class="display" style="width:100%;" id="tblAssessmentPendingList"></table>
        </div>
      </div>
    </div>
  </div>

</div>


<!--Action popup Page-->
<div id="btnPopupartDetails" class="modal" style="position: fixed !important;display:none">
  <div class="modal-dialog modal-xl custome-modal">
    <div class="modal-content" id="modal_contentArt">
      <div class="modal-header" style="text-align:center">
        <h4 class="modal-title">Freelancer Info {{vendorname}} </h4>
        <button type="button" class="close" data-dismiss="modal" (click)="hide()">×</button>
      </div>
      <!--popupbody-->
      <div class="modal-body" id="popupbody">
        <div id="LoadingImagePopup1">
          <img src="assets/Images/loader.gif" class="imgLoadimg" />
        </div>
        <ul class="nav nav-tabs nav-tabs-custom" id="ULTabul">
          <li class="nav-item"><a class="nav-link active" data-toggle="tab" href="#divFreelancertab">Freelancer Details</a></li>
          <li class="nav-item"><a class="nav-link" data-toggle="tab" href="#divTestassigntab">Test assign</a></li>
        </ul><br />

        <div class="tab-content">
          <div class="tab-pane active" id="divFreelancertab">
            <div class="form-group">
              <div class="row">
                <div class="col-sm-4">
                  Name<em>*</em>
                  <input id="Txt_Name" type="text" class="form-control skipSpecialChar" maxlength="40" autocomplete="off" />
                </div>
                <div class="col-sm-4">
                  Email ID<em>*</em>
                  <input id="Txt_EmailID" type="text" class="form-control" maxlength="40" autocomplete="off" (change)="onSearchChange($event)" />
                </div>

                <div class="col-sm-4">
                  Alternate Email ID
                  <input type="text" class="form-control" id="Txt_AltEmailID" maxlength="40" autocomplete="off" (change)="emailIdOnly($event)" />
                </div>
              </div>

            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-sm-4">
                  Microsoft Team Id
                  <input id="Txt_TeamID" type="text" class="form-control " maxlength="40" autocomplete="off" (change)="emailIdOnly($event)" />
                </div>
                <div class="col-sm-4">
                  Mobile No.
                  <input type="text" id="Txt_mobile" class="form-control IsNumeric" (change)="numbervalidate($event)" maxlength="10" autocomplete="off">
                </div>
                <div class="col-sm-2">
                  DOB
                  <input type="date" name="DOB" class="form-control float-right" id="Txt_DOB" autocomplete="off" (change)="Dobdatevalidation($event)">
                </div>
                <div class="col-sm-2">
                  Gender
                  <select class="form-control" id="ddlGender">
                    <option value="0" selected disabled>Select</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-10">
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-12">
                      Address
                      <input type="text" class="form-control" id="Txt_address" autocomplete="off" />
                    </div>

                  </div>
                  <br />
                  <div class="form-group">
                    <div class="row">
                      <div class="col-sm-3">
                        City
                        <select class="form-control" id="ddlCity">
                          <option value="0" disabled selected>Select City</option>
                          <option *ngFor="let itemCT of CityList" value={{itemCT.ID}} [selected]="itemCT.ID==CityIDPop">{{itemCT.CityName}}</option>
                        </select>
                      </div>
                      <div class="col-sm-3">
                        State
                        <select class="form-control" id="ddlState" (change)="GetCity(0,0)">
                          <option value="0" disabled selected>Select State</option>
                          <option *ngFor="let itemS of StateList" value={{itemS.ID}} [selected]="itemS.ID==StateIDPop">{{itemS.StateName}}</option>
                        </select>
                      </div>
                      <div class="col-sm-3">
                        Country
                        <select class="form-control" id="ddlCountry" (change)="GetState(0)">
                          <option value="0" disabled selected>Select Country</option>
                          <option *ngFor="let itemC of CountryList" value={{itemC.ID}}>{{itemC.CountryName}}</option>
                        </select>
                      </div>
                      <div class="col-sm-3">
                        Pincode
                        <input type="text" class="form-control IsNumeric" id="Txt_pincode" maxlength="6" autocomplete="off" />
                      </div>

                    </div>
                  </div>
                </div>

              </div>
              <!--profile-->
              <div class="col-sm-2">

                <div class="input-group" style="text-align:center;">
                  <img src="../../../assets/Images/userLogo.jpg" alt="Profile" style="height:110px;width:110px;margin-top:10px;border-radius:10px;" id="imgProfile" (error)="onerrorImageLoad()" /> <br /><br />
                  <input type="file" name="file" id="imageUploadForm" style="width: 100%;margin-left:10px" class="btn" (change)="showPreview($event)" />
                </div>
              </div>

            </div>

            <div class="row form-group">
              <div class="col-sm-6">
                Source<em>*</em>
                <select id="ddlSourceList" class="form-control" multiple>
                  <option *ngFor="let item of sourceList" value={{item.ID}}>
                    {{item.SourceName}}
                  </option>
                </select>
              </div>
              <div class="col-sm-6">
                Languages<em>*</em>
                <select id="ddlLanguageList" class="form-control" multiple>
                  <option *ngFor="let item of languageList" value={{item.ID}}>
                    {{item.Language}}
                  </option>
                </select>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-sm-6">
                Interest<em>*</em>
                <select id="ddlInterestList" class="form-control" multiple>
                  <option *ngFor="let item of interestList" value={{item.ID}}>
                    {{item.Subject}}
                  </option>
                </select>
              </div>
              <div class="col-sm-6">
                Restriction
                <select id="ddlRestrictionList" class="form-control" multiple>
                  <option *ngFor="let item of interestList" value={{item.ID}}>
                    {{item.Subject}}
                  </option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                Category List<em>*</em>
                <select id="ddlCategory" class="form-control" multiple>
                  <option *ngFor="let item of CategoryList" value={{item.ID}}>
                    {{item.TaskName}}
                  </option>
                </select>
              </div>
              <div class="col-sm-6">
                Additional Information<em>*</em>
                <input type="text" class="form-control" id="Txt_information" maxlength="6" autocomplete="off" />
              </div>
            </div>
            <br />
            <div class="form-group" id="grpAcceptDecline" style="display:none;">
              <div class="btn-group float-right">
                <button class="btn btn-success" (click)="UpdateAccept()">Accept</button>
                <button class="btn btn-danger" style="left:10px !important" (click)="Decline()">Decline</button>
              </div>
            </div>
          </div>

          <!--Test assign Details -->
          <div class="tab-pane" id="divTestassigntab">
            <div class="form-group">
              <div class="row">
                <div class="col-sm-4">
                  <label>Category List</label>
                  <select class="form-control select2" id="ddlTestCategory">
                    <option *ngFor="let item of TestCategoryList" value={{item.ID}}>
                      {{item.TaskName}}
                    </option>
                  </select>
                </div>
                <div class="col-sm-4">
                  <button class="btn btn-outline-info waves-effect waves-light proofingAddbtn" style="top:20px" (click)="testassignpopup()">
                    <i class="fa fa-plus"></i>
                  </button>
                </div>
              </div>
              <span id="btnLoadList" class="" (click)="testassignpopup()" style="display:none"></span>
              <span id="Showfreelists" class="" (click)="downloadtestfileassign()" style="display:none"></span>
              <span id="btnUploadedTestFile" class="" (click)="downloadUploadedTestFile()" style="display:none"></span>
              <span id="SpDeletetestAssign" class="" (click)="DeleteTestTransConfirmation()" style="display:none"></span>
              <span id="btnAssessmentShow" class="" (click)="assessmentPopup()" style="display:none"></span>
              <span id="btnAssessmentInfo" class="" (click)="assessmentInfo()" style="display:none"></span>
              <button type="button" id="btndeleteconfig" (click)="Deletefileassign()" style="display:none"></button>
              <br />
              <div class="form-group row">
                <!--<h3 style="padding-left:1em !important;">Test Assigned</h3>-->
                <!--<div class="col">-->
                <div class="col-12">
                  <table id="tblTaskSer" class="tblTrans table" width="100%">
                    <thead>
                      <tr>
                        <th class="textAlign">S.No.</th>
                        <th class="textAlign">Category</th>
                        <th class="textAlign">Article No</th>
                        <th class="textAlign">Expected Start Date</th>
                        <th class="textAlign">Due Date</th>
                        <th class="textAlign">Uploaded Date</th>
                        <th class="textAlign">Evaluation Date</th>
                        <th style="text-align:center">Actions</th>
                      </tr>
                    </thead>
                    <tbody></tbody>
                  </table>
                </div>
                <!--</div>-->
                <!--<div class="col-md-12">
                  <div class="form-group tblRightsList fixTableHead">
                  </div>
                </div>-->
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
<!--[style.display]="showpopupTestassign ? 'block' : 'none'"-->

<div id="modalPopupInvite" class="modal" style="position: fixed !important;display:none;">
  <div class="modal-dialog modal-lg custome-modal">
    <div class="modal-content" id="modal_contentArt">
      <div class="modal-header" style="text-align:center">
        <h4 class="modal-title"> Invitation </h4>
        <button type="button" class="close" data-dismiss="modal" (click)="hide()">×</button>
      </div>
      <!--Loader gif-->
      <div id="LoadingImagePopup">
        <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
      </div>

      <div class="modal-body">
        <ul class="nav nav-tabs nav-tabs-custom" id="InviteTabul">
          <li class="nav-item" id="idFreelancer"><a class="nav-link active" data-toggle="tab" href="#divFreelancerInvite">Freelancer Details</a></li>
          <li class="nav-item" id="idMail"><a class="nav-link" data-toggle="tab" href="#divMailInvite">Mail Body</a></li>
          <li class="nav-item" id="idPreview"><a class="nav-link" data-toggle="tab" (click)="showInvitePreview()" href="#divPreviewInvite">Preview</a></li>
        </ul><br />

        <div class="tab-content">
          <div class="tab-pane active" id="divFreelancerInvite">

            <div class="row form-group">
              <div class="col-sm-2">
                First Name<em>*</em>
                <input id="txtFreelancerFirstName" type="text" class="form-control skipSpecialChar" maxlength="40" autocomplete="off" />
              </div>
              <div class="col-sm-2">
                Middle Name
                <input id="txtFreelancerMiddleName" type="text" class="form-control skipSpecialChar" maxlength="40" autocomplete="off" />
              </div>
              <div class="col-sm-2">
                Last Name
                <input id="txtFreelancerLastName" type="text" class="form-control skipSpecialChar" maxlength="40" autocomplete="off" />
              </div>
              <div class="col-sm-6">
                Email ID<em>*</em>
                <input id="txtFreelancerEmail" type="text" class="form-control" maxlength="40" autocomplete="off" (change)="onSearchChange($event)" />
              </div>

            </div>

            <div class="row form-group">
              <div class="col-sm-8" id="divMainFilter">
                CategoryList<em>*</em>
                <select id="ddlFreelancerCat" class="form-control select2" multiple style="position: fixed !important;">
                  <option *ngFor="let item of CategoryList" value={{item.ID}}>
                    {{item.TaskName}}
                  </option>
                </select>
              </div>
              <div class="col-sm-4">
                <button class="btn btn-outline-info waves-effect waves-light proofingAddbtn" title="Add Freelancer" style="top:20px" (click)="AddInviteFreelancer()">
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </div>

            <div class="form-group col-12 tblRightsList fixTableHead">
              <table id="tblAddFreelancerInvite" class="table" Style="width:100%">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>First Name</th>
                    <th>Middle Name</th>
                    <th>Last Name</th>
                    <th class='EmailIDFreelancer'>Email</th>
                    <th>Category List</th>
                    <th style='display:none;'>CategoryIDS</th>
                    <th style='text-align: center'>Actions</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>

          </div>

          <div class="tab-pane" id="divMailInvite">
            <div class="row form-group">
              <div class="col-sm-4">
                From Email<em>*</em>
                <input id="txtFromInvite" type="text" class="form-control skipSpecialChar" autocomplete="off" (change)="onSearchChange($event)" />
              </div>
              <div class="col-sm-4">
                To Email<em>*</em>
                <input id="txtToInvite" type="text" class="form-control skipSpecialChar" autocomplete="off" (change)="onSearchChange($event)" />
              </div>
              <div class="col-sm-4">
                CC Email
                <input id="txtCCInvite" type="text" class="form-control skipSpecialChar" autocomplete="off" (change)="onSearchChange($event)" />
              </div>


            </div>
            <div class="row form-group">
              <div class="col-sm-4">
                BCC Email
                <input id="txtBCCInvite" type="text" class="form-control" autocomplete="off" (change)="onSearchChange($event)" />
              </div>
              <div class="col-sm-8">
                Subject<em>*</em>
                <input id="txtSubjectInvite" type="text" class="form-control" autocomplete="off" />
              </div>
            </div>
            <div class="row form-group">

              <div class="col-sm-12" id="Divmail">
                Mail Body<em>*</em>
                <textarea id="Txt_MailBody" class="form-control rounded-0" autocomplete="off" data-origin="textarea"> </textarea>
              </div>


            </div>
          </div>
          <!--Test assign Details -->
          <div class="tab-pane" id="divPreviewInvite">
            <div class="row form-group">
              <div class="col-sm-4">
                From Email<em>*</em>
                <input id="txtFromInvitePreview" disabled type="text" class="form-control skipSpecialChar" autocomplete="off" (change)="onSearchChange($event)" />
              </div>
              <div class="col-sm-4">
                To Email<em>*</em>
                <input id="txtToInvitePreview" disabled type="text" class="form-control skipSpecialChar" autocomplete="off" (change)="onSearchChange($event)" />
              </div>
              <div class="col-sm-4">
                CC Email
                <input id="txtCCInvitePreview" disabled type="text" class="form-control skipSpecialChar" autocomplete="off" (change)="onSearchChange($event)" />
              </div>


            </div>
            <div class="row form-group">
              <div class="col-sm-4">
                BCC Email
                <input id="txtBCCInvitePreview" disabled type="text" class="form-control" autocomplete="off" (change)="onSearchChange($event)" />
              </div>
              <div class="col-sm-8">
                Subject<em>*</em>
                <input id="txtSubjectInvitePreview" disabled type="text" class="form-control" autocomplete="off" />
              </div>
            </div>
            <div class="row form-group" id="divPreviewMain" style="overflow: hidden; overflow-y: auto;">
              <div id="divPreviewData"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
        <button type="submit" (click)="SendInvite()" class="btn btn-outline-success waves-effect waves-light">Invite</button>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="myModalDecline" [style.display]="showModal ? 'block' : 'none'">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Decline</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="hideDecline()">&times;</button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <div class="row">
            <div class="col-sm-12" id="popupdecline">
              Reason For Decline<em>*</em>
<textarea type="text" class="form-control" rows="10" id="txt_declineReason"> </textarea>
            </div>&nbsp;
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideDecline()">Close</button>
          <button type="submit" (click)="AddUpdateDeclineReason()" class="btn btn-outline-success waves-effect waves-light">Save</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="TestassignPopup">
  <div class="modal-dialog modal-xl">
    <div class="modal-content" id="modal_contentArt">
      <!--popup Header-->
      <div class="modal-header">
        <h4 class="modal-title">TEST ASSIGNMENT</h4>
        <!--<button type="button" class="close" data-dismiss="modal" (click)="Testassignhide()">×</button>-->
      </div>
      <app-test-assignment></app-test-assignment>
    </div>
  </div>
  <div id="LoadingImageReopen">
    <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
  </div>
</div>


<!--[style.display]="showpopupTestassessment ? 'block' : 'none'"-->

<div class="modal" id="Testassessmentpopup">
  <div class="modal-dialog modal-xl">
    <div class="modal-content" id="modal_contentArt">
      <!--popup Header-->
      <div class="modal-header">
        <h4 class="modal-title">TEST ASSESSMENT</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="Testassessmenthide()">×</button>
      </div>
      <app-test-assessment></app-test-assessment>
    </div>
  </div>
  <div id="LoadingImagePopup2">
    <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
  </div>
</div>


<div id="btnTestDetails" class="modal" style="position: fixed !important;">
  <div class="modal-dialog modal-xl custome-modal">
    <div class="modal-content" id="modal_contentArt">
      <div class="modal-header" style="text-align:center">
        <h4 class="modal-title">Test Assesment Details </h4>
        <button type="button" class="close" data-dismiss="modal" (click)="testassesmentpopup()">×</button>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="AssessmentInfoPopup">
  <div class="modal-dialog modal-xl">
    <div class="modal-content" id="modal_contentArt">
      <!--popup Header-->
      <div class="modal-header">
        <h4 class="modal-title">Assessment Info</h4>
        <button type="button" class="close" data-dismiss="modal" (click)="AssessmentInfoHide()">×</button>
      </div>
      <div class="modal-body DetailScroll" id="tblpopupfreelancer">

        <div class="row">
          <div class="col-sm-12" id="tblVendorAllocation">
            <table class="tblBkinfo tblMain table table-bordered" width="100%">
              <tbody>
                <tr>
                  <td class="main"><b>Result</b></td>
                  <td id="text_Result"></td>
                  <td class="main"><b>Score</b></td>
                  <td id="text_Score"></td>
                </tr>
                <tr>
                  <td class="main"><b>Remarks</b></td>
                  <td id="text_Remarks" colspan="3"></td>

                </tr>
              </tbody>
            </table>
          </div>

          <div class="modal-emoji emoji-table">
            <div class="form-group">
              <div class="row" id="CopyeditingData">
                <div class="col-sm-12" id="tblVendorChecklist">
                  <label>Checklist</label>
                  <table class="tblBkinfo tblMain table table-bordered" id="tbl_checklist" width="100%">
                    <thead>
                      <tr class="main">
                        <th>S.No </th>
                        <th>Areas</th>
                        <th>FeedBack</th>
                      </tr>
                    </thead>
                    <tbody>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="row">
              <div class="col-sm-12" id="tblassessmentsummary">
                <label>Summary</label>

                <table id="tbl_summarylist" class="tblBkinfo tblMain table table-bordered" width="100%">
                  <thead>
                    <tr class="main">
                      <th>S.No</th>
                      <th>Issues</th>
                      <th>Examples</th>
                      <th style="width:10%">Page #</th>

                    </tr>
                  </thead>
                  <tbody>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- Modal footer -->

      </div>
    </div>
  </div>
  <div id="LoadingImageMeta">
    <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
  </div>
</div>

<!--</div>-->
